export default "__VITE_ASSET__DBxwUTXo__"